const garSubscription = {
  garSubscriptions: "GAR-Abonnements",
  subscriptionDetails: "Abonnementdetails",
  subscriptionUpdate: "Abonnement bearbeiten",
  updateWarning:
    "Achtung: Sobald ein Abonnement begonnen hat, sind nur Änderungen erlaubt, um das Enddatum zu verlängern oder die Anzahl der Lizenzen zu erhöhen.",
  title: "GAR-Schulabonnements",
  startValidity: "Abonnementbeginn",
  endValidity: "Abonnementende",
  affectationType: "Zugewiesen an",
  licences: "Lizenzen",
  subscribeEstablishment: "Ein GAR‑Schulabonnement erstellen",
  projectCode: "Projektcode",
  projectCodeError:
    "Der angegebene Projektcode existiert nicht und wurde daher nicht gespeichert.",
  maxSubscriptionStart:
    "Das Startdatum des Abonnements darf 10 Jahre nach dem Erstellungsdatum des Abonnements nicht überschreiten.",
  searchEstablishment: "Schule suchen",
  estNameOrUAI: "Name der Schule oder UAI",
  deptNumber: "Departementsnummer (optional)",
  searchNoResult: "Keine Schule entspricht Ihrer Suche.",
  licencesType: "Lizenztyp",
  global: "Global",
  targetPublic: "Nach Zielgruppe",
  nbGlobalLicences: "Gesamtanzahl Lizenzen",
  nbStudentLicences: "Schülerlizenzen",
  nbTeacherLicences: "Lehrer­lizenzen",
  nbProfDocLicences: "Lehrer-Bibliothekar-Lizenzen",
  nbOtherStaffLicences: "Lizenzen für weiteres Personal",
  unlimited: "Unbegrenzt",
  OR: "ODER",
  deleteSubscription: "Abonnement löschen",
  deleteSubscriptionVerif: "Dieses Abonnement löschen?",
};

export default garSubscription;
